import { $, GraphQLTypes, InputType, Selector } from '../lib/generated/zeus';
import { useTypedLazyQuery } from '../lib/generated/zeus/apollo';
import { genericScalars } from '../lib/graphql/helpers';
import { eventSelector } from './selectors/event';

export const teamCreated = 'queryEventTeamCreated';

const eventCreatedSelector = Selector('event_team_created')({
  event: eventSelector,
});

/**
 * Team GraphQL data schema, represents stored data.
 */
export type EventTeamCreated = InputType<
  GraphQLTypes['event_team_created'],
  typeof eventCreatedSelector,
  typeof genericScalars
>;

/**
 * Provides GraphQL query to fetch a Team.
 * Using query instead of team_by_pk as query by primary key does not filter out Deleted record.
 * @param onCompleted callback for handling result.
 * @param onError callback for handling error.
 * @param id of the Team to fetch.
 * @param skip determines if the query should be skipped.
 * @returns custom hook that provides GraphQL query to fetch Team by ID.
 */
const useLazyQueryEventTeamCreated = () =>
  useTypedLazyQuery(
    {
      event_team_created: [
        { where: { team_id: { _eq: $('teamId', 'uuid!') } } },
        eventCreatedSelector,
      ],
    },
    {
      scalars: genericScalars,
      operationOptions: { operationName: teamCreated },
    }
  );

export default useLazyQueryEventTeamCreated;
